import React, { Component } from 'react';
//import FacebookLogin from 'react-facebook-login';
import { LinkedIn } from 'react-linkedin-login-oauth2';
import { origin, saveKey } from "utils/Helper";
import { apiUrl } from 'Api/Api';
import axios from 'axios';
import { local_routes } from 'utils/Routes';
import './style.css';

class LinkedIn_Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      errorMessage: '',
      originData: window.localStorage.getItem('loginOrigin')
    };
  }


  handleSuccess = async (data) => {
    console.log("LINKED IN SUCCESS",data);
    this.setState({
      code: data.code,
      errorMessage: '',
    });
    let auth_obj = {
        access_token: data.code,
        callback_url: window.location.protocol + '//' + window.location.hostname + '/linkedin'
    }
    let auth_response = await axios.post(`${apiUrl}authenticate/linkedin`,auth_obj);
    console.log("AUTH RESPONSE",auth_response.data);
    let UserData = { "UserMail": null, "login_Auth_Res": auth_response.data }
    saveKey("UserData", JSON.stringify(UserData));
    if (this.state.originData) {
        if (this.state.originData === "pkCreation") {
            window.localStorage.removeItem('loginOrigin');
            window.location.href = `${local_routes.pkcreation}`;
        } else {
            // redirect back to loginOrigin
            window.localStorage.removeItem('loginOrigin');
            window.location.href = this.state.originData;
        }
    } else {
        window.location.href = origin;
    }

  }

  handleFailure = (error) => {
    console.log("LINKED IN ERROR",error);
    this.setState({
      code: '',
      errorMessage: error.errorMessage,
    });
    if (this.props.stopLoading) {
      this.props.stopLoading();
    }
    /*
    if (this.state.originData) {
        if (this.state.originData === "pkCreation") {
            window.localStorage.removeItem('loginOrigin');
            window.location.href = `${local_routes.pkcreation}`;
        } else {
            // redirect back to loginOrigin
            window.localStorage.removeItem('loginOrigin');
            window.location.href = this.state.originData;
        }
    } else {
        window.location.href = origin;
    }
    */
  }
  
  render() {
    const { code, errorMessage } = this.state;
    
    return (
      <div>
        <LinkedIn
            clientId="780u0k7vldkhm3"
            onFailure={this.handleFailure}
            onSuccess={this.handleSuccess}
            scope="r_emailaddress r_liteprofile"
            redirectUri={window.location.protocol + '//' + window.location.hostname + '/linkedin'}
            renderElement={({ onClick, disabled }) => (
                <div className="linkedin-login">
                    <button onClick={onClick} disabled={disabled}><i className="fa fa-linkedin " aria-hidden="true"></i>&nbsp;&nbsp;LinkedIn</button>
                </div>
            )}
        />
        {/*
        {!code && <div>No code</div>}
        {code && <div>Code: {code}</div>}
        {errorMessage && <div>{errorMessage}</div>}
        */}
      </div>
    );
  }
}

export default LinkedIn_Login;